import React from 'react';

const Settings: React.FC = () => (
    <section className="settings-page">
        <h1>Settings &amp; Assumptions</h1>
        <p className="page-subtitle">
            Tailor the calculator to match the economics of your appointment-based business. These guardrails can help
            you pick realistic inputs before modelling ROI.
        </p>

        <div className="settings-grid">
            <div className="settings-card">
                <h2>Lead &amp; Funnel Metrics</h2>
                <ul>
                    <li><strong>Monthly leads:</strong> start with inbound inquiries or booked consultations.</li>
                    <li>
                        <strong>Booking rate:</strong> percentage of leads that commit to an appointment. Benchmark 30–
                        60%.
                    </li>
                    <li>
                        <strong>Show rate:</strong> % of booked appointments that attend. Include reminders and deposits
                        to improve it.
                    </li>
                    <li>
                        <strong>Close rate:</strong> % of attended appointments that convert to paying clients.
                    </li>
                </ul>
            </div>

            <div className="settings-card">
                <h2>Revenue &amp; Retention</h2>
                <ul>
                    <li>
                        <strong>Average sale value:</strong> revenue from an initial appointment or package.
                    </li>
                    <li>
                        <strong>Retention rate:</strong> portion of new clients who return for future visits.
                    </li>
                    <li>
                        <strong>Retention months:</strong> average number of repeat visits the retained clients make.
                    </li>
                </ul>
            </div>

            <div className="settings-card">
                <h2>Costs</h2>
                <ul>
                    <li>
                        <strong>Marketing spend:</strong> monthly investment in ads, outreach, or partnerships that
                        drive leads.
                    </li>
                    <li>
                        <strong>Other costs:</strong> staff, software, or fulfillment expenses needed to deliver the
                        service.
                    </li>
                </ul>
            </div>
        </div>

        <div className="settings-note">
            <h2>Tip</h2>
            <p>
                Track these metrics in your booking system or CRM each month. Updating the calculator with real data
                makes each scenario more reliable and shows exactly where optimization will unlock additional profit.
            </p>
        </div>
    </section>
);

export default Settings;
